import React, { ChangeEvent, FC, MouseEvent, ReactNode } from "react";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";
import { Square, SquareCheckBig } from "lucide-react";
import { Box, makeStyles } from "@material-ui/core";
import classNames from "classnames";

interface ICustomCheckBox {
  name: string;
  isSubmitted?: boolean;
  isChecked: boolean;
  onCheck: (e: ChangeEvent<HTMLInputElement>) => any;
  label: ReactNode | string;
  allPointer?: boolean;
  errorMessage?: ReactNode;
}
const useStyles = makeStyles((theme) => ({
  text: {
    fontSize: ".75rem",
    lineHeight: 1.5,
    whiteSpace: "normal",
    overflowWrap: "break-word",
  },
  textError: {
    color: theme.palette.error.main,
  },
  textPrimary: {
    color: theme.palette.primary.main,
  },
}));

const CustomCheckBox: FC<ICustomCheckBox> = (props) => {
  const {
    name,
    isSubmitted,
    isChecked,
    onCheck,
    label,
    allPointer,
    errorMessage,
  } = props;
  const classes = useStyles();

  return (
    <FormControlLabel
      style={{ pointerEvents: allPointer ? "auto" : "none" }}
      control={
        <Checkbox
          checked={isChecked}
          onChange={onCheck}
          onClick={(e: MouseEvent) => e.stopPropagation()}
          color="primary"
          icon={<Square size={18} />}
          checkedIcon={<SquareCheckBig size={18} />}
          className={
            isSubmitted && !isChecked ? classes.textError : classes.textPrimary
          }
          style={{ pointerEvents: "auto" }}
        />
      }
      label={
        <>
          {label}
          {isSubmitted && !isChecked && errorMessage && (
            <Box
              className={classNames(classes.text, classes.textError)}
              marginBottom={2}
            >
              {errorMessage}
            </Box>
          )}
        </>
      }
      labelPlacement="end"
      name={name}
    />
  );
};

export default CustomCheckBox;
